import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datetimeEquals',
    standalone: false,
})
export class DatetimeEqualsPipe implements PipeTransform {
    transform(value: Date, equals: Date): unknown {
        const val = new Date(value);
        const eq = new Date(equals);

        return val.getTime() === eq.getTime();
    }
}
